import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10500578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-none d-md-flex timer-rounded" }
const _hoisted_2 = {
  class: "timer-svg",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { class: "timer-circle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "timer-path-elapsed",
  cx: "50",
  cy: "50",
  r: "45"
}, null, -1))
const _hoisted_5 = ["stroke-dasharray"]
const _hoisted_6 = { class: "timer-label" }
const _hoisted_7 = { class: "d-flex d-md-none timer-progress" }
const _hoisted_8 = { class: "text-md" }

import { QuizzType } from '@/types/Quizz'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import ProgressBar from '../ProgressBar.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    quizzType: null
  },
  emits: ['onTimerEnd'],
  setup(__props: any, { emit }) {

const props = __props as {
  quizzType: QuizzType
}





const timeLimit = computed(() => {
  switch (props.quizzType) {
    case QuizzType.QCM:
      return process.env.VUE_APP_QUIZZ_QCM_TIMER
    case QuizzType.ILLUSTRATION:
      return process.env.VUE_APP_QUIZZ_ILLUSTRATION_TIMER
    default:
      return process.env.VUE_APP_QUIZZ_DEFAULT_TIMER
  }
})

const timeLeft = ref(timeLimit.value)

let timerInterval: number | null = null

onMounted(() => {
  startTimer()
})

onUnmounted(() => {
  stopTimer()
})

function startTimer() {
  stopTimer()

  timerInterval = setInterval(() => {
    timeLeft.value -= 1

    if (timeLeft.value < 0) {
      if (timerInterval) {
        emit('onTimerEnd')

        clearInterval(timerInterval)
      }
    }
  }, 1000)
}

function stopTimer() {
  if (timerInterval) {
    clearInterval(timerInterval)
  }
}

function formatTimeLeft(time: number) {
  const seconds = time

  if (seconds < 10) {
    return seconds >= 0 ? `0${seconds}”` : '00”'
  }

  return `${seconds}”`
}

const timeFraction = computed(() => timeLeft.value / timeLimit.value)

const circleDasharray = computed(() => {
  const dasharray = `${(timeFraction.value * 283).toFixed(0)} 283`

  return dasharray
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("g", _hoisted_3, [
          _hoisted_4,
          (timeLeft.value >= 0)
            ? (_openBlock(), _createElementBlock("path", {
                key: 0,
                "stroke-dasharray": _unref(circleDasharray),
                class: "timer-path-remaining",
                d: "\r\n          M 50, 50\r\n          m -45, 0\r\n          a 45,45 0 1,0 90,0\r\n          a 45,45 0 1,0 -90,0\r\n        "
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ])),
      _createElementVNode("span", _hoisted_6, _toDisplayString(formatTimeLeft(timeLeft.value)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ProgressBar, {
        progress: _unref(timeFraction) * 100
      }, null, 8, ["progress"]),
      _createElementVNode("span", _hoisted_8, _toDisplayString(formatTimeLeft(timeLeft.value)), 1)
    ])
  ], 64))
}
}

})